export default {
    'zh_CN': {
        'system.config.id.label': '参数主键',
        'system.config.id.holder': '请输入参数主键',


        'system.config.id.required': '参数主键必填',
        'system.config.name.label': '参数名称',
        'system.config.name.holder': '请输入参数名称',
        'system.config.name.max': '参数名称最多100个字符',

        'system.config.name.required': '参数名称必填',
        'system.config.sign.label': '参数键名',
        'system.config.sign.holder': '请输入参数键名',
        'system.config.sign.max': '参数键名最多100个字符',

        'system.config.sign.required': '参数键名必填',
        'system.config.content.label': '参数键值',
        'system.config.content.holder': '请输入参数键值',
        'system.config.content.max': '参数键值最多500个字符',

        'system.config.content.required': '参数键值必填',
        'system.config.type.label': '系统类型',
        'system.config.type.holder': '请输入系统类型',


        'system.config.type.dictionary': ()=>[{value:0,label:'系统外置'},{value:1,label:'系统内置'}],
        'system.config.type.required': '系统类型必填',
        'system.config.remark.label': '备注',
        'system.config.remark.holder': '请输入备注',
        'system.config.remark.max': '备注最多500个字符',

        'system.config.remark.required': '备注必填',
        'system.config.createTime.label': '创建时间',
        'system.config.createTime.holder': '请输入创建时间',
        'system.config.createTime.required': '创建时间必填',
        'system.config.updateTime.label': '更新时间',
        'system.config.updateTime.holder': '请输入更新时间',
        'system.config.updateTime.required': '更新时间必填',
        'system.config.deleted.label': '是否删除',
        'system.config.deleted.holder': '请输入是否删除',
        'system.config.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'system.config.id.label': '参数主键',
        'system.config.id.holder': '請輸入参数主键',


        'system.config.id.required': '参数主键必填',
        'system.config.name.label': '参数名称',
        'system.config.name.holder': '請輸入参数名称',


        'system.config.name.required': '参数名称必填',
        'system.config.sign.label': '参数键名',
        'system.config.sign.holder': '請輸入参数键名',


        'system.config.sign.required': '参数键名必填',
        'system.config.content.label': '参数键值',
        'system.config.content.holder': '請輸入参数键值',


        'system.config.content.required': '参数键值必填',
        'system.config.type.label': '系统类型',
        'system.config.type.holder': '請輸入系统类型',


        'system.config.type.required': '系统类型必填',
        'system.config.remark.label': '备注',
        'system.config.remark.holder': '請輸入备注',


        'system.config.remark.required': '备注必填',
        'system.config.createTime.label': '创建时间',
        'system.config.createTime.holder': '請輸入创建时间',


        'system.config.createTime.required': '创建时间必填',
        'system.config.updateTime.label': '更新时间',
        'system.config.updateTime.holder': '請輸入更新时间',


        'system.config.updateTime.required': '更新时间必填',
        'system.config.deleted.label': '是否删除',
        'system.config.deleted.holder': '請輸入是否删除',


        'system.config.deleted.required': '是否删除必填'
    },
    'en_US': {
        'system.config.id.label': 'id',
        'system.config.id.holder': 'Enter id',
        'system.config.id.max': 'id max length: 参数主键',


        'system.config.id.required': 'id required',
        'system.config.name.label': 'name',
        'system.config.name.holder': 'Enter name',
        'system.config.name.max': 'name max length: 参数名称',


        'system.config.name.required': 'name required',
        'system.config.sign.label': 'sign',
        'system.config.sign.holder': 'Enter sign',
        'system.config.sign.max': 'sign max length: 参数键名',


        'system.config.sign.required': 'sign required',
        'system.config.content.label': 'content',
        'system.config.content.holder': 'Enter content',
        'system.config.content.max': 'content max length: 参数键值',


        'system.config.content.required': 'content required',
        'system.config.type.label': 'type',
        'system.config.type.holder': 'Enter type',
        'system.config.type.max': 'type max length: 系统类型',


        'system.config.type.required': 'type required',
        'system.config.remark.label': 'remark',
        'system.config.remark.holder': 'Enter remark',
        'system.config.remark.max': 'remark max length: 备注',


        'system.config.remark.required': 'remark required',
        'system.config.createTime.label': 'createTime',
        'system.config.createTime.holder': 'Enter createTime',
        'system.config.createTime.max': 'createTime max length: 创建时间',


        'system.config.createTime.required': 'createTime required',
        'system.config.updateTime.label': 'updateTime',
        'system.config.updateTime.holder': 'Enter updateTime',
        'system.config.updateTime.max': 'updateTime max length: 更新时间',


        'system.config.updateTime.required': 'updateTime required',
        'system.config.deleted.label': 'deleted',
        'system.config.deleted.holder': 'Enter deleted',
        'system.config.deleted.max': 'deleted max length: 是否删除',


        'system.config.deleted.required': 'deleted required'
    }
}
